(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-comparison-slides"] && !window.DesignMode) return;
  try {
    
 $productComparisonSlider = $('.comparison-slides');
  settings = {
      arrows: true,
      dots: true,
      slidesToShow: 1,
      fade: true,
      cssEase: 'linear',
      speed: 300,
      prevArrow: '<button type="button" class="prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none"><path class="arrowBg" fill="#202324" d="M28 56C12.536 56 0 43.464 0 28S12.536 0 28 0s28 12.536 28 28-12.536 28-28 28z"/><path fill="#fff" d="M31.7424 17.7241c.3798 0 .7217.2303.8646.5822.1429.3519.0584.7553-.2138 1.0202l-8.6734 8.6734 8.6734 8.6734c.2438.2341.342.5818.2568.9088-.0853.3271-.3407.5825-.6678.6678-.3271.0853-.6747-.0129-.9088-.2568l-9.3333-9.3333c-.3644-.3645-.3644-.9553 0-1.3198l9.3333-9.3333c.1757-.1807.417-.2826.669-.2826z"/></svg></button>',
      nextArrow: '<button type="button" class="next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" fill="none"><path class="arrowBg" fill="#202324" d="M28 .0000049C43.464.0000076 56 12.536 56 28S43.464 56 28 56 .0000022 43.464.0000049 28C.0000076 12.536 12.536.0000022 28 .0000049z"/><path fill="#fff" d="M24.2576 38.2759c-.3798 0-.7217-.2303-.8646-.5822-.1429-.3519-.0584-.7553.2138-1.0202l8.6735-8.6734-8.6735-8.6734c-.2438-.2341-.342-.5818-.2568-.9088.0853-.3271.3407-.5825.6678-.6678.3271-.0853.6747.0129.9088.2568l9.3333 9.3333c.3644.3645.3644.9553 0 1.3198l-9.3333 9.3333c-.1757.1807-.417.2826-.669.2826z"/></svg></button>'
  }
  $productComparisonSlider.slick(settings);

  if (!$productComparisonSlider.hasClass('slick-initialized')) {
    return $productComparisonSlider.slick(settings);
  }

  $productComparisonSlider.on('init beforeChange', function(event, slick, currentSlide, nextSlide){
    $currentSlideAttr = $("[data-slick-index='" +nextSlide+ "']").find('.comparison-slide').attr('style');
    $('.product__comparison').attr("style", $currentSlideAttr);
  });

  $(window).on('load resize orientationchange', function () {
    $productComparisonSlider.slick('resize');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-featured-on-meta"] && !window.DesignMode) return;
  try {
    
 $featuredOnSlider = $('.product__featured-on .grid');
  settings = {
      arrows: false,
      dots: true,
      slidesToShow: 3,
      centerMode: true,
      variableWidth: true,
      adaptiveHeight: false,
      mobileFirst: true,
  }
  $featuredOnSlider.slick(settings);
  $(window).on('load resize orientationchange', function () {
      if ($(window).width() > 601) {
          if ($featuredOnSlider.hasClass('slick-initialized')) {
              $featuredOnSlider.slick('unslick');
          }
          return
      }
      if (!$featuredOnSlider.hasClass('slick-initialized')) {
          return $featuredOnSlider.slick(settings);
      }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-featured-on"]) return;
  try {
    
 $featuredOnSlider = $('.product__featured-on .grid');
  settings = {
      arrows: false,
      dots: true,
      slidesToShow: 3,
      centerMode: true,
      variableWidth: true,
      adaptiveHeight: false,
      mobileFirst: true,
  }
  $featuredOnSlider.slick(settings);
  $(window).on('load resize orientationchange', function () {
      if ($(window).width() > 601) {
          if ($featuredOnSlider.hasClass('slick-initialized')) {
              $featuredOnSlider.slick('unslick');
          }
          return
      }
      if (!$featuredOnSlider.hasClass('slick-initialized')) {
          return $featuredOnSlider.slick(settings);
      }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero-multi-flavor-bundle"]) return;
  try {
    
$(document).ready(function() {
        productNextPrevImage();
    });

    function productNextPrevImage() {
        var productThumbFirst = $('#ProductThumbs .product-single__photo-wrapper:first-child .product-single__thumbnail'),
            productThumbLast = $('#ProductThumbs .product-single__photo-wrapper:last-child .product-single__thumbnail');
        $('.product-single__control--prev').click(function () {
            if($(productThumbFirst).hasClass("active-thumb")) {
                $(productThumbLast).trigger("click");
            } else {
                $('.product-single__thumbnail.active-thumb')
                    .parent()
                    .prev('.product-single__photo-wrapper')
                    .find('.product-single__thumbnail')
                    .trigger("click");
            }
            var container = $('#ProductThumbs'),
                scrollTo = $('.product-single__photo-wrapper a.active-thumb');
            container.animate({
                scrollLeft: scrollTo.offset().left - container.offset().left + container.scrollLeft()
            }, 100 );
        });

        $('.product-single__control--next').click(function () {
            if($(productThumbLast).hasClass("active-thumb")) {
                $(productThumbFirst).trigger("click");
            } else {
                $('.product-single__thumbnail.active-thumb')
                    .parent()
                    .next('.product-single__photo-wrapper')
                    .find('.product-single__thumbnail')
                    .trigger("click");
            }
            var container = $('#ProductThumbs'),
                scrollTo = $('.product-single__photo-wrapper a.active-thumb');
            container.animate({
                scrollLeft: scrollTo.offset().left - container.offset().left + container.scrollLeft()
            }, 100 );
        });
        $('.product-single__form .single-option-radio label').click(function () {
            setTimeout(function () {
                var container = $('#ProductThumbs'),
                    scrollTo = $('.product-single__photo-wrapper a.active-thumb').parent();

                container.animate({
                    scrollLeft: scrollTo.offset().left - container.offset().left + container.scrollLeft()
                }, 100);

            }, 100);
        });
        setTimeout(function () {
            var container = $('#ProductThumbs'),
                scrollTo = $('.product-single__photo-wrapper a.active-thumb').parent();
            container.animate({
                scrollLeft: scrollTo.offset().left - container.offset().left + container.scrollLeft()
            }, 100);
        }, 200);
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-hero"]) return;
  try {
    
    $(document).ready(function() {
        productNextPrevImage();
    });

    function productNextPrevImage() {
        var productThumbFirst = $('#ProductThumbs .product-single__photo-wrapper:first-child .product-single__thumbnail'),
            productThumbLast = $('#ProductThumbs .product-single__photo-wrapper:last-child .product-single__thumbnail');
        $('.product-single__control--prev').click(function () {
            if($(productThumbFirst).hasClass("active-thumb")) {
                $(productThumbLast).trigger("click");
            } else {
                $('.product-single__thumbnail.active-thumb')
                    .parent()
                    .prev('.product-single__photo-wrapper')
                    .find('.product-single__thumbnail')
                    .trigger("click");
            }
            var container = $('#ProductThumbs'),
                scrollTo = $('.product-single__photo-wrapper a.active-thumb');
            container.animate({
                scrollLeft: scrollTo.offset().left - container.offset().left + container.scrollLeft()
            }, 100 );
        });

        $('.product-single__control--next').click(function () {
            if($(productThumbLast).hasClass("active-thumb")) {
                $(productThumbFirst).trigger("click");
            } else {
                $('.product-single__thumbnail.active-thumb')
                    .parent()
                    .next('.product-single__photo-wrapper')
                    .find('.product-single__thumbnail')
                    .trigger("click");
            }
            var container = $('#ProductThumbs'),
                scrollTo = $('.product-single__photo-wrapper a.active-thumb');
            container.animate({
                scrollLeft: scrollTo.offset().left - container.offset().left + container.scrollLeft()
            }, 100 );
        });
        $('.product-form__item .single-option-radio label').click(function () {
            setTimeout(function () {
                var container = $('#ProductThumbs'),
                    scrollTo = $('.product-single__photo-wrapper a.active-thumb').parent();

                container.animate({
                    scrollLeft: scrollTo.offset().left - container.offset().left + container.scrollLeft()
                }, 100);

            }, 100);
        });
        setTimeout(function () {
            var container = $('#ProductThumbs'),
                scrollTo = $('.product-single__photo-wrapper a.active-thumb').parent();
            container.animate({
                scrollLeft: scrollTo.offset().left - container.offset().left + container.scrollLeft()
            }, 100);
        }, 200);
    }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-team-usage"] && !window.DesignMode) return;
  try {
    
	$teamUsageSlider = $('.product__team-usage--slickjs');
    settings = {
        adaptiveHeight: true,
        arrows: false,
        centerMode: true,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
    }
    $teamUsageSlider.slick(settings);

    $(window).on('load resize orientationchange', function () {
        if ($(window).width() > 1023) {
            if ($teamUsageSlider.hasClass('slick-initialized')) {
                $teamUsageSlider.slick('unslick');
            }
            return
        }
        if (!$teamUsageSlider.hasClass('slick-initialized')) {
            return $teamUsageSlider.slick(settings);
        }
    });

  } catch(e) { console.error(e); }
})();
})();
